import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import tak from "../images/tak.jpg";
import broschyr1 from "../images/tak/broschyr1.jpg";
import broschyr2 from "../images/tak/broschyr2.jpg";
import broschyr3 from "../images/tak/broschyr3.png";
import broschyr4 from "../images/tak/broschyr4.png";
import styles from "../app.module.scss";
import { Link } from "react-router-dom";

export const PageFixRoof = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h2>Dags att Uppgradera Din Tak?</h2>
        <img src={tak} alt="Jämföra" className={styles.fullW} />

        <p>
          Ett alternativ till att byta tak är att behandla befintliga takpannor
          och därmed förlänga livstiden på dem. Se Broschyr nedan:
        </p>

        <div className={styles.previewsBox}>
          <div className={styles.preview}>
            <Link to={broschyr1} target="_blank">
              <img src={broschyr1} width="100%" alt="Broschyr 1" />
            </Link>
          </div>

          <div className={styles.preview}>
            <Link to={broschyr2} target="_blank">
              <img
                src={broschyr2}
                width="100%"
                alt="Broschyr 2"
                className={styles.preview}
              />
            </Link>
          </div>

          <div className={styles.preview}>
            <Link
              to={process.env.PUBLIC_URL + "/broschyr3.pdf"}
              target="_blank"
            >
              <img
                src={broschyr3}
                width="100%"
                alt="Broschyr 3"
                className={styles.preview}
              />
            </Link>
          </div>

          <div className={styles.preview}>
            <Link
              to={process.env.PUBLIC_URL + "/broschyr4.pdf"}
              target="_blank"
            >
              <img
                src={broschyr4}
                width="100%"
                alt="Broschyr 4"
                className={styles.preview}
              />
            </Link>
          </div>
        </div>

        <h3>Ser det intressant ut?</h3>

        <p>
          Du kan kontakta Thomas Sommar, Daltorpsvägen 48 eller Mats Ahlgren för
          mer information.
        </p>

        <p>Du kan naturligtvis vända dig direkt till företaget också</p>
      </ContentBox>
      <FooterBar />
    </>
  );
};
